import { LANGUAGE_REGEX } from "../../regex/LANGUAGE_REGEX";

import type { EnabledLanguageIsoCode } from "~config/ENABLED_LANGUAGES.config";

export const getLanguageFromSlug = (slug?: string): EnabledLanguageIsoCode => {
  const matches = slug && slug.match(LANGUAGE_REGEX);

  return (matches && (matches[1] as EnabledLanguageIsoCode)) || "en-gb";
};
